import {NodeImplChunk} from "../../chunks/types/NodeImplChunk";
import {ChunkType} from "../../chunks/types/ChunkType";

/**
 * Determines whether the specified node implementation chunk implements the
 * node with code for the specified target.
 * @param nodeImplChunk
 */
export function isCodeNodeImplChunk(
  nodeImplChunk: NodeImplChunk
): boolean {
  const {children = []} = nodeImplChunk;
  return children
    .reduce(
      (result, next) =>
        result || next.type === ChunkType.NodeCode,
      false as boolean);
}
